import type { SelectHTMLAttributes, FC } from 'react';

import { cn } from './cn.js';

/*
 * Нативный <select>: доступность, клавиатура и мобильные пикеры достаются бесплатно.
 * Кастомный дропдаун на Radix заведём, когда понадобится то, чего нативный не умеет
 * (поиск по опциям, множественный выбор, произвольная разметка строки).
 */
export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

const CHEVRON =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>\")";

export const Select: FC<SelectProps> = ({ className, style, ...rest }) => (
  <select
    className={cn(
      'h-[34px] cursor-pointer appearance-none rounded-[7px] border border-ink-200 bg-white',
      'py-0 pr-7 pl-2.5 text-[13px] text-ink-700 hover:border-ink-300',
      'focus-visible:border-brand-green focus-visible:ring-2 focus-visible:ring-brand-green-50',
      'focus-visible:outline-none',
      className,
    )}
    style={{
      backgroundImage: CHEVRON,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 10px center',
      ...style,
    }}
    {...rest}
  />
);
